export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">联系我们</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              如果您有漫画资源推荐、合作意向或任何问题反馈，欢迎通过以下方式与我们取得联系。我们期待听到您的声音！
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">投稿与合作</div>
                  <div className="text-sm font-medium text-foreground-900">contact@waiwaimanga.com</div>
                </div>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                  <i className="ri-message-3-line text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">读者反馈</div>
                  <div className="text-sm font-medium text-foreground-900">feedback@waiwaimanga.com</div>
                </div>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
                  <i className="ri-shake-hands-line text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">商务合作</div>
                  <div className="text-sm font-medium text-foreground-900">biz@waiwaimanga.com</div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm cursor-pointer"
              >
                <i className="ri-question-line"></i>
                查看常见问题
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-50 transition-colors whitespace-nowrap text-sm cursor-pointer"
              >
                <i className="ri-star-line"></i>
                了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md">
            <img
              src="https://readdy.ai/api/search-image?query=Friendly%20customer%20support%20illustration%20with%20speech%20bubbles%20and%20envelope%20icons%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20modern%20flat%20illustration%20style%2C%20clean%20white%20background%2C%20approachable%20and%20welcoming%20vibe%2C%20professional%20yet%20playful%20composition&width=800&height=600&seq=contact-manga-01&orientation=landscape"
              alt="联系我们"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}